import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SharedModule } from 'src/app/modules/shared.module';
import { BatchDiscussionQaFormComponent } from './batch-discussion-qa-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { GoogleRECAPTCHAModule } from 'src/app/popupModel/google-recaptcha/google-recaptcha.module';

@NgModule({
  declarations: [BatchDiscussionQaFormComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
        { path: ':category', component: BatchDiscussionQaFormComponent }, //PATTERN 3
        { path: ':category/:question', loadChildren: () => import(/* webpackChunkName: "read-answer" */ '../read-answer/read-answer.module').then(m => m.ReadAnswerModule), data: { preload: true } }, //PATTERN 2
        // { path: ':category/:question', component: ReadAnswerComponent }, //PATTERN 2
        { path: ':gradeId/:subjectId', component: BatchDiscussionQaFormComponent },
        { path: ':category/:catid/:questionId/:question', loadChildren: () => import(/* webpackChunkName: "read-answer" */ '../read-answer/read-answer.module').then(m => m.ReadAnswerModule), data: { preload: true } }, //PATTERN 1
        // { path: ':category/:catid/:questionId/:question', component: ReadAnswerComponent }, //PATTERN 1
        { path: '', component: BatchDiscussionQaFormComponent },
    ]),
    SharedModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    GoogleRECAPTCHAModule
],
  providers: [DecimalPipe]
})
export class BatchDiscussionQaFormModule { }
